import React, { useEffect } from "react";
import Collapsible from "../Collapsible";
import { apiCall } from "./aiservice";
import { aiServiceBaseUrl } from "../aiComponent";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import { sendEvent } from "../../modules/helpers/Analytics";
import { useChat } from "./aiContext";

export type ChunkData = {
  document?: {
    id: string;
    path: string[];
    title: string;
    types: string[];
    
  };
  excerpt?: string;
  parents?: string[];
  title?: string;
  url?: string;
  type: "external" | "internal";
};

type PropType = {
  id: string;
  indexName?: string;
};

export default function Chunk(props: PropType) {
  const [chunkData, setChunkData] = React.useState<ChunkData>({});
  const [pendingFetch, setPendingFetch] = React.useState<boolean>(true);
  const [fetchSuccessful, setFetchSuccessful] = React.useState<boolean>(false);
  const { setAiModalState } = useChat();

  React.useEffect(() => {
    if (!!props.id) {
      callGetChunk(props.id, props.indexName);
    }
  }, []);

  // GetChunk based on its id
  function callGetChunk(id: string, indexName?: string) {
    if (indexName) {
      if (localStorage[id + indexName]) {
        let parsedCh = JSON.parse(localStorage[id + indexName]) as ChunkData;
        setChunkData(parsedCh);
        setFetchSuccessful(true);
        setPendingFetch(false);
      } else {
        apiCall(aiServiceBaseUrl + "/getchunk/" + id + "/" + indexName)
          .then((data: string) => {
            if (!!data) {
              try {
                let parsedChunk = JSON.parse(data) as ChunkData;
                localStorage[id + indexName] = data;
                setChunkData(parsedChunk);
                setFetchSuccessful(true);
              } catch (e) {
                console.info("Chunk error: ", e);
                setFetchSuccessful(false);
              }
            }
          })
          .catch((error) => {
            console.info("chunk error: ", error);
            setFetchSuccessful(false);
          })
          .finally(() => {
            setPendingFetch(false);
          });
      }
    }
    else{
      setPendingFetch(false);
    }
  }

  function getChunkTitle(chunkData: ChunkData): string {
    let title = "";
    if (!!chunkData?.document) {
      title += chunkData.document?.title ?? "";
      if (chunkData.document?.types[0] === "Regel" && !!chunkData.title) {
        title += ", " + chunkData.title;
      }
    }
    return title;
  }

  function mapChunkIcons(name: string): string {
    switch (name) {
      case "Regel":
        return "rule";
      case "Förarbete":
        return "prework";
      case "Disciplinärende":
        return "discipline";
      case "Rättsfall":
        return "legalcase";
      case "Tidningsartikel":
        return "newsarticle";
      default:
        return "rule";
    }
  }

  function fromAI(url: string | undefined): string {
    if (url == undefined) {
      return "";
    }
    let urlWIthParams = new URL(url);
    urlWIthParams.searchParams.append("fromAISearch", "true");
    return urlWIthParams.href;
  }

  return pendingFetch ? (
    <span className="blocker__loader" />
  ) : (
    fetchSuccessful && (
      <div className="item">
        <Collapsible
          tags={chunkData.document?.types}
          title={getChunkTitle(chunkData)}
          className={`item-type item-type__${
            chunkData.type === "internal" ? "education" :
            chunkData.document?.types[0]
              ? mapChunkIcons(chunkData.document?.types[0])
              : "rule"
          }`}
        >
          <div className="targetLink-container">
            <a
              className="targetLink"
              onClick={() => {
                sendEvent("ai-source-click", undefined, {
                  pageTitle: chunkData?.document?.title,
                  documentType: chunkData.document?.types[0],
                });
                setAiModalState("small");
              }}
              href={fromAI(chunkData?.url)}
            >
              Gå till källa
            </a>
          </div>
          {chunkData?.excerpt && (
            <div className="collapsibleContent">
              <ReactMarkdown remarkPlugins={[remarkGfm]}>
                {chunkData?.excerpt}
              </ReactMarkdown>
            </div>
          )}
        </Collapsible>
      </div>
    )
  );
}
